// removed by extract-text-webpack-plugin
module.exports = {"link":"_393mT","wrapper":"YKrNr","linkActive":"_19tXH","count":"D3EOz","zeroCount":"bszn-"};


//////////////////
// WEBPACK FOOTER
// ./app/components/menu-tab/menu-tab.scss
// module id = 1585
// module chunks = 0